import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const CYRCLibrarySilentReadingSessionsConducted = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Silent reading sessions conducted" />
    </Box>
  );
};
